const changePanoramicStep = (state, action) => {
  if (state === undefined) {
    return 1;
  }

  switch (action.type) {
    case "CHANGE_PANORAMIC_STEP":
      return action.payload;
    default:
      return state.panoramicBillingPageStep;
  }
};

export { changePanoramicStep };
